// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"Ly","firstSessionModal_header":"My","firstSessionModal_title":"Ny","firstSessionModal_header_tex":"Oy","firstSessionModal_video":"Py","firstSessionModal_videoContent":"Qy","firstSessionModal_FAQ":"Ry","firstSessionModal_FAQMargin":"Sy","firstSessionModal_FAQTitle":"Ty","firstSessionModal_buttonContainer":"Uy","firstSessionModal_buttonText":"Vy","firstSessionModal_SMSBtn_mob":"Wy"};
    if(module.hot) {
      // 1714654886323
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  